import { Message } from "@arco-design/web-react";
import { ManageApis } from "../../APIS/ManageApis";
import { handleApiError, removeLocalStorage } from "../../Utils/Utils";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const validateToken = async (
  setValidatingToken,
  setTokenValidated,
  authgetToken,
  usergetId,
  showAlert,
  navigate
) => {
  try {
    if (!authgetToken) {
      return;
    }
    setValidatingToken(true);
    const res = await ManageApis("post", window.validateResetPasswordUrl, {
      userId: usergetId,
      token: authgetToken,
    });
    await delay(3000);
    const { message, status_code, response_data } = res || {};
    const { status, message: responseMessage = "", data } = response_data || {};
    if (status_code === 200 && message === "Success") {
      if (data?.isValid == true) {
        setTokenValidated(true);
      } else {
        removeLocalStorage("AuthToken");
        removeLocalStorage("userId");
        Message.error(data?.message || "Invalid or expired link");
        navigate("/login");
      }
    } else {
      handleApiError(status, message, status_code, showAlert);
    }
  } catch (err) {
    console.error(err);
    Message.error("Something went wrong. Try again.");
    navigate("/login");
  } finally {
    setValidatingToken(false);
  }
};
